export default {
  activated() {
    window.scrollTo({ top: this.$route.meta.scrollTop })
  },
}